import "./datatable.scss";
import { DataGrid, GridToolbar } from "@mui/x-data-grid";
import {
  expenseColumns,
  expenseRows,
  fetchExpenseRows,
} from "../../datatablesource";
import { Link } from "react-router-dom";
import { useState, useEffect } from "react";
import { useSlug } from "../../SlugContext";
import { serverUrl } from "../../temp";
import Loader from "../loader/Loader";

const ExpenseDataTable = () => {
  const [data, setData] = useState(expenseRows);
  const [loading, setLoading] = useState(false);
  const { slugs } = useSlug();
  const [downloadDisabled, setDownloadDisabled] = useState(false); // New state for download button
  useEffect(() => {
    const getData = async () => {
      setLoading(true);
      const rows = await fetchExpenseRows();
      console.log("jawad", rows);
      setLoading(false);
      setData(Array.from(rows.data));
    };
    getData();
  }, []);

  const handleDelete = (id) => {
    // Make a DELETE request to the Flask API endpoint
    fetch(`${serverUrl}/del_examination/${id}`, {
      method: "DELETE",
      headers: {
        "Content-Type": "application/json",
      },
    })
      .then((response) => {
        if (!response.ok) {
          throw new Error("Network response was not ok");
        }
        // Remove the item from your React data state if the API request is successful
        setData(data.filter((item) => item.id !== id));
      })
      .catch((error) => {
        console.error("There was a problem with the fetch operation:", error);
      });
  };
  const handleSheet = () => {
    setDownloadDisabled(true); // Disable button when clicked

    fetch(
      `${serverUrl}/expense-sheet?centerId=${localStorage.getItem(
        "center_id",
      )}`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
        },
      },
    )
      .then((response) => response.blob())
      .then((blob) => {
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.href = url;
        a.download = "cash_record.xlsx";
        document.body.appendChild(a);
        a.click();
        a.remove();
      })
      .catch((error) => {
        console.error("Error:", error);
      })
      .finally(() => {
        setDownloadDisabled(false); // Re-enable button when done (success or error)
      });
  };
  const viewLinkString = "Expense-Single";
  const editLinkString = "Expense-Edit";
  const newLinkString = "Expense-New";

  const actionColumn = [
    {
      field: "action",
      headerName: "Action",
      width: 200,
      renderCell: (params) => {
        return (
          <div className="cellAction">
            {slugs && slugs.includes(viewLinkString) && (
              <Link
                to={`/expense/${params.row.id}`}
                style={{ textDecoration: "none" }}
              >
                <div className="viewButton">View</div>
              </Link>
            )}
            {slugs && slugs.includes(editLinkString) && (
              <Link
                to={`/expense/update-expense/${params.row.id}`}
                style={{ textDecoration: "none" }}
              >
                <div className="editButton">Edit</div>
              </Link>
            )}
            <div
              className="deleteButton disabled"
              onClick={() => handleDelete(params.row.id)}
            >
              Delete
            </div>
          </div>
        );
      },
    },
  ];
  return (
    <div className="datatable">
      <div className="flex flex-col lg:flex-row lg:items-center lg:justify-between w-full gap-3 pb-2 lg:pb-2">
        {/* Title */}
        <div className="text-gray-700 text-2xl">Expenses</div>

        {/* Buttons */}
        <div className="flex flex-col sm:flex-row gap-2 w-full lg:w-auto">
          <button
            className={`commonButton w-full sm:w-auto ${downloadDisabled ? "disabled" : ""}`}
            onClick={handleSheet}
            disabled={downloadDisabled}
          >
            {downloadDisabled ? "Downloading..." : "Download Expense File"}
          </button>
          {slugs && slugs.includes(newLinkString) && (
            <Link to="/expense/new" className="commonButton w-full sm:w-auto">
              Add New
            </Link>
          )}
        </div>
      </div>
      {loading ? (
        // <h1 style={{ textAlign: "center", paddingTop: "20%" }}>loading...</h1>
        <Loader fullScreen={false} />
      ) : (
        <DataGrid
          className="datagrid"
          rows={data}
          columns={expenseColumns.concat(actionColumn)}
          pageSize={9}
          rowsPerPageOptions={[9]}
          components={{
            Toolbar: GridToolbar, // Include the GridToolbar in the Toolbar slot
          }}
          // checkboxSelection
        />
      )}
    </div>
  );
};

export default ExpenseDataTable;
